function capitaliseFirstLetterFilter() {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel'],
        link(scope, element, attrs, ctrls) {
            const ngModel = ctrls[0];

            return scope.$watch(attrs.ngModel, (newval, oldval) => {
                if (newval) {
                    let string = scope.$eval(attrs.ngModel);
                    string = string.charAt(0).toUpperCase() + string.slice(1);
                    ngModel.$setViewValue(string);
                    ngModel.$render();
                    return;
                }
            });
        }
    };
}

angular
    .module('BB')
    .directive('bbCapitaliseFirstLetter', capitaliseFirstLetterFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/capitalize-first-letter/capitalize_first_letter.directive.js